import { useEffect, useState } from "react";
import axios from "axios";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import {
  Button,
  Form,
  Header,
  Divider,
  Segment,
  Input,
  Checkbox,
  Label,
} from "semantic-ui-react";
import { useNavigate } from "react-router";
import "semantic-ui-css/semantic.min.css";
import "../old.scss";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import { useEncrypt } from "../../../../hooks/useEncrypt";
export const CronogramaActividades = () => {
  const stateError = {
    apertura: false,
    cierre: false,
    otorgamiento: false,
  };
  const [principalError, setPrincipalError] = useState(stateError);
  const [actividades, setActividades] = useState([]);
  const [actividadessource, setActividadessource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const history = useNavigate();
  const { decrypt } = useEncrypt();

  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));


  useEffect(() => {
    handleCargarActividades();
  }, []);
  const handleCargarActividades = async () => {

    const token = localStorage.getItem('token');
    let ActividadesSelecionadas = await obtenerConvocatoria();
    return await axios
      .get(`${process.env.REACT_APP_SERVER_MAES}actividades`, {
        headers: {
          'Authorization': token
        }
      })
      .then(async ({ data }) => {
        let actividadesmap = data.map((ds) => {
          let f = ActividadesSelecionadas.filter(x => x.id == ds.id)
          let check = false
          if (f.length > 0) {
            check = f[0].check
          } else if (['Apertura', 'Cierre', 'Resolución de otorgamiento'].indexOf(ds.nombre) >= 0) {
            check = true
          }
          return {
            id: ds.id,
            nombre: ds.nombre,
            check,
            key: ds.id,
          };
        });
        let todoJSON = JSON.parse(JSON.stringify(actividadesmap));
        setActividades(todoJSON);
        setActividadessource(todoJSON);

        return true;
      })
      .catch(function (error) {
        console.error(error);
      });
  };
  const obtenerConvocatoria = async () => {
    const token = localStorage.getItem('token')
    return await axios
      .get(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/${idConvocatoria}`,
        {
          headers: {
            'Authorization': token
          }
        }
      )
      .then(({ data }) => {

        if (data.data && data.data.actividades && data.data.actividades.length > 0) {
          return data.data.actividades
        } else {
          return []
        }
      })
      .catch(function (error) {
        return []
      });
  };

  const handletoggleChange = (event, result, actividad, index) => {
    setInputSearch("");
    let actividadChange = actividadessource.map(x => {
      if (x.id == actividad.id) {
        x.check = !actividad.check;
        if (['Apertura', 'Cierre', 'Resolución de otorgamiento'].indexOf(actividad.nombre.trim()) >= 0 && !x.check) {
          setPrincipalError({
            ...principalError,
            apertura: actividad.nombre.trim() === 'Apertura' ? false : principalError.apertura,
            cierre: actividad.nombre.trim() === 'Cierre' ? false : principalError.cierre,
            otorgamiento: actividad.nombre.trim() === 'Resolución de otorgamiento' ? false : principalError.otorgamiento,
          });
        }
      }
      return x;

    })
    return setActividades(actividadChange);
  };
  const handelGuardarActiviadesConvocatorias = async () => {
    setLoading(true);
    console.log('actividades', actividades);
    let actividadesSeleccionadas = actividades.filter((data) => data.check);
    let apertura = actividades.filter(
      (data) => data.nombre === "Apertura" && data.check === true
    );
    let cierre = actividades.filter(
      (data) => data.nombre === "Cierre" && data.check === true
    );
    let otorgamiento = actividades.filter(
      (data) =>
        data.nombre === "Resolución de otorgamiento" && data.check === true
    );
    let arrayErrores = stateError;
    let error = false;
    if (apertura.length === 0) {
      error = true;
      arrayErrores = {
        ...arrayErrores,
        apertura: true,
      };
    }
    if (cierre.length === 0) {
      error = true;
      arrayErrores = {
        ...arrayErrores,
        cierre: true,
      };
    }
    if (otorgamiento.length === 0) {
      error = true;
      arrayErrores = {
        ...arrayErrores,
        otorgamiento: true,
      };
    }
    if (error) {
      setLoading(false);
      return setPrincipalError(arrayErrores);
    }
    const objActividades = {
      actividades: actividadesSeleccionadas,
    };
    const token = localStorage.getItem('token')
    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/actividades/${idConvocatoria}`,
        objActividades, {
        headers: {
          'Authorization': token
        }
      }
      )
      .then(({ data }) => {
        ObjNotificaciones.MSG_SUCCESS("success", data.mensaje);
        setLoading(false);
        history("/Administrador/cronograma");
      })
      .catch(function (error) {
        console.error(error);
      });
  };
  const filtradodeinformacion = (e) => {
    setInputSearch(e.target.value)
    if (inputSearch === "") {
      return setActividades(actividadessource);
    }
    let filtrado = actividadessource.filter(
      (data) =>
        data.nombre.toUpperCase().indexOf(e.target.value.toUpperCase()) >= 0
    );
    return setActividades(filtrado);
  };
  const seleccionarTodo = (e, value) => {
    let todoJSON = JSON.parse(JSON.stringify(actividades));
    for (var i in todoJSON) {
      if (todoJSON[i]) {
        if (value.checked) {
          todoJSON[i].check = true;
        } else {
          todoJSON[i].check = false;
        }
      }
    }
    return setActividades(todoJSON);
  };
  const backComponente = () => {
    history("/administrador/infoconvocatoria");
  };

  const routes = [{ nombre: "Crear convocatoria" }];

  return (
    <div className="container-flexbox background-color-F7FBFF height-100">
      <div className="no-margin">
        <div className="col-12 background-color-101c31 no-margin no-padding-top no-padding-bottom">
          <BreadCrumbAdmin routes={routes} />
        </div>
      </div>
      <Navegador
        idconvocatorias={idConvocatoria}
        activo="Cronograma Actividades"
      />
      <div className="container-principal pb-3 background-color-F7FBFF main-c3">
        <div className="col-12 no-margin">
          <Form onSubmit={handelGuardarActiviadesConvocatorias}>
            <Segment className="segment-shadow">
              <Header as="h4" floated="right" style={{ marginBottom: "0.5%" }}>
                <span className="font-color-B0B0B0 font-family-Montserrat-Thin font-size-12px">
                  Código de convocatoria: {idConvocatoria}
                </span>
              </Header>
              <Header as="h4" style={{ marginBottom: "0.5%" }} floated="left">
                Seleccionar actividades
              </Header>
              <Divider
                clearing
                style={{ marginTop: "0", marginBottom: "16px" }}
              />
              <div>
                <div className="row">
                  <div className="col-12 col-md-8">
                    <Input
                      icon="search"
                      placeholder="Buscar por Nombre..."
                      fluid
                      value={inputSearch}
                      onChange={filtradodeinformacion}
                    />
                  </div>
                  <div className="col-12 col-md-4 mt-3">
                    <Header as="h4" floated="right">
                      <Form.Checkbox
                        onChange={seleccionarTodo}
                        label={
                          <label className="font-color-4B4B4B font-size-12px font-weight-400">
                            Seleccionar todo
                          </label>
                        }
                        name="dinamico"
                      />
                    </Header>
                  </div>
                </div>
              </div>

              <Segment className="container_checks">
                <div
                  style={{ paddingTop: "1%" }}
                  className="row checkbox-padding"
                >
                  {actividades.length > 0
                    ? actividades.map((actividad, index) => (
                      <div
                        className="col-12 col-md-6 col-lg-4 checkbox-padding"
                        key={actividad.idactividad}
                      >
                        <Checkbox
                          label={
                            <label className="font-color-4B4B4B font-family-Work-Sans font-size-12px font-weight-normal">
                              {actividad.nombre}
                            </label>
                          }
                          key={actividad.key}
                          value={actividad.idactividad}
                          name={actividad.nombre}
                          checked={actividad.check}
                          className="check pt-2 pb-2"
                          onChange={(event, result) =>
                            handletoggleChange(
                              event,
                              result,
                              actividad,
                              index
                            )
                          }
                        />
                      </div>
                    ))
                    : null}
                </div>
              </Segment>
              {principalError.apertura ? (
                <Label color="red">Falta seleccionar la Apertura</Label>
              ) : null}
              {principalError.cierre ? (
                <Label color="red">Falta seleccionar el Cierre</Label>
              ) : null}
              {principalError.otorgamiento ? (
                <Label color="red">
                  Falta seleccionar la Resolución de otorgamiento
                </Label>
              ) : null}
            </Segment>
          </Form>
        </div>
      </div>

      <nav className="buttonNext border-top pe-3 justify-content-start bg-white">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={backComponente}
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="font-size-12px  button-azul-radius"
              color="blue"
              onClick={handelGuardarActiviadesConvocatorias}
              disabled={loading}
            >
              Guardar y continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
      </nav>
    </div>
  );
};
